function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-2{fill:#fff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M3,9H29a2,2,0,0,0,0-4H3A2,2,0,0,0,3,9Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M29,14H3a2,2,0,0,0,0,4H29a2,2,0,0,0,0-4Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M29,23H3a2,2,0,0,0,0,4H29a2,2,0,0,0,0-4Z"
});

var SvgList = function SvgList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 32 32",
    width: "25px",
    height: "25px",
    ref: svgRef
  }, props), _ref2, React.createElement("title", null, title), _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list.4b7ee449.svg";
export { ForwardRef as ReactComponent };